import React, {Component} from 'react';
import {BaseEventEditor, BaseEventViewer} from './base_event';
import {RelatedToOptions} from '../../../constants.js.erb';

class ComTextMessageEditor extends BaseEventEditor {
  formFields() {
    let {patient} = this.props;
    return formFields(patient);
  }
}


class ComTextMessageViewer extends BaseEventViewer {
  formFields() {
    let {patient} = this.props;
    return formFields(patient);
  }
}


export default {
  viewer: ComTextMessageViewer,
  editor: ComTextMessageEditor
}


function formFields(patient) {
  let contacts = patient.contacts.map(c => {return {id: c.id, text: c.name}});
  let medical_team_members = patient.medical_team_members.map(m => {return {id: m.id, text: m.person.name}});

  return [
    {name: 'date', type: 'date', label: 'Date Text Message was Received', required: true, inSummary: true},
    {name: 'date_estimated', label: 'Date Estimated?', type: 'bool'},
    {name: 'related_to', type: 'select', collection: RelatedToOptions},
    {name: 'user', inSummary: true, label: 'Text Message sent to (person or number)'},
    {name: 'peer_type', type: 'select', collection: ['patient', 'contact', 'medical_team', 'other'], labelTransform: 'titleize', label: 'Text Message sent by'},
    {name: 'contact_id', type: 'select2', collection: contacts, visible: e => e.peer_type === 'contact', idField: 'id', labelField: 'text', hint: 'To appear here, contacts must be added to the patient.'},
    {name: 'medical_team_member_id', type: 'select2', collection: medical_team_members, visible: e => e.peer_type === 'medical_team', idField: 'id', labelField: 'text', hint: 'To appear here, medical team members must be added to the patient.'},
    {name: 'description', type: 'text', inSummary: true, label: 'Text Message Notes/Description'}
  ];
}
